import './styles.scss'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Clock from 'react-clock'
import { Carousel } from 'primereact/carousel'
import { SelectButton } from 'primereact/selectbutton'
import { ClockSetting, DragIcon } from 'Assets/Icons'
import { getLocalClockDisplay, getLocalClockTab, getLocalTimeFormat, getLocalUserDetails, setLocalWithClockTab, setLocalDigitalClocksReorder, getLocalDigitalClocksReorder } from 'Utils/LocalStorage_Handler'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import { commonMethods } from 'Utils/commonMethods'
import CustomDropdown from 'Components/CustomDropdown'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import useAnalytics from 'Utils/useAnalytics'
import { USER_EVENTS } from 'Utils/Constants/analyticsEvents'
import ErrorMessageModal from 'Components/UIComponent/ConfirmationModal'
import ClockSettings from './Components/MyClockSettingsModal'

const AnalogClock = ({ ...props }) => {
  const { mockDisplayTab, mockSelectedCountryData, mockSelectedCountry, showError } = props

  const { t } = useTranslation()
  const userDetails = getLocalUserDetails()
  const carouselRef = useRef(null)
  const autoScrollRef = useRef(null)
  const dragGhostRef = useRef(null)
  const isHoveringEdgeRef = useRef(false)
  const lastScrollTimeRef = useRef(0)
  const containerRef = useRef(null)

  const { isLoading, setLoading } = useContext(CoffeeWebContext)
  const { trackEvent } = useAnalytics()
  let carouselValue

  const defaultCountryData = {
    countryName: 'India',
    flagURL: 'https://coffeeweb.s3.ap-south-1.amazonaws.com/Masters/Flags/IND.svg',
    gmtOffSet: 'UTC +05:30',
    roundOffSet: '+5.5',
    currentTime: '2024-03-14T15:36:57.8199849Z',
    timeZone: 'Asia/Kolkata'
  }

  const computeVisibleItems = (width) => {
    if (width >= 1400) return 5
    if (width >= 924) return 4
    if (width >= 767) return 3

    return 1
  }

  const clockList = ['All Clock', 'My Favourite']
  const [page, setPage] = useState(0)
  const [clockDataForAllCountries, setClockDataForAllCountries] = useState([])
  const [favoriteCountryClock, setFavoriteCountryClock] = useState([])
  const [pickListSourceData, setPickListSourceData] = useState([])
  const [pickListTargetData, setPickListTargetData] = useState([])
  const [countryTime, setCountryTime] = useState({})
  const [digitalClockTime, setDigitalClockTime] = useState({})
  const [digitalTimeHour, setDigitalTimeHour] = useState({})
  const [digitalClock, setDigitalClock] = useState({})
  const [digitalPeriod, setDigitalPeriod] = useState({})
  const [countryDay, setCountryDay] = useState({})
  const [selectedCountry, setSelectedCountry] = useState({})
  const [filterCountry, setFilterCountry] = useState({})
  const [visible, setVisible] = useState(false)
  const [selectedCountryData, setSelectedCountryData] = useState(null)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [clockTab, setClockTab] = useState(() => getLocalClockTab('clockTab') || 'All Clock')
  const [selectedClockType, setSelectedClockType] = useState(() => getLocalClockDisplay('selectedClockDisplay') || 'Digital')
  const [timeFormat, setTimeFormat] = useState(() => getLocalTimeFormat('selectedTimeFormat') || '12-hour')
  const [isCountryPresent, setIsCountryPresent] = useState(false)
  const [numScrollCount, setNumScrollCount] = useState(1)
  const [errorState, setErrorState] = useState(false)
  const [numScroll, setNumScroll] = useState(3) // To control the count of data swiped in carousel
  const [pageLoad, setPageLoad] = useState(false) // To recognize page mount
  const [allClockData, setAllClockData] = useState([]) // To store all 243 countries data
  const [pageCount, setPageCount] = useState(0) // To maintain global Page Count
  const [displayTab, setDisplayTab] = useState(false) // To handle Tab Switch
  const [numVisible, setNumVisible] = useState(4)
  const [draggedItem, setDraggedItem] = useState(null)

  useEffect(() => {
    setSelectedClockType(getLocalClockDisplay('selectedClockDisplay') || 'Digital')
  }, [getLocalClockDisplay('selectedClockDisplay')])

  useEffect(() => {
    setTimeFormat(getLocalTimeFormat('selectedTimeFormat') || '12-hour')
  }, [getLocalClockDisplay('selectedTimeFormat')])

  useEffect(() => {
    getAllCountryTimeDetails()

    const updateFromContainer = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth

        setNumVisible(computeVisibleItems(width))
      }
    }

    updateFromContainer()

    const observer = new ResizeObserver(() => updateFromContainer())

    if (containerRef.current) observer.observe(containerRef.current)

    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    if (page > pageCount) {
      // To execute only on forward page movement
      setPageCount((prev) => prev + 1)
      if (page % 4 === 0) {
        // Slicing Data on every 4th page in forward direction, based on numScroll i.e. countries swiped on one click
        setClockDataForAllCountries([...clockDataForAllCountries, ...allClockData.slice((page + 1) * numScroll + (numVisible - numScroll), (page + 1) * numScroll + (numVisible - numScroll) + numScroll * 4)])
      }
    }
  }, [page])

  useEffect(() => {
    if (!isCountryPresent && pageLoad) {
      getGeolocation()
    }

    if (clockDataForAllCountries?.length) {
      const displayButton = clockDataForAllCountries?.some((ele) => ele.isFavorite) || allClockData?.some((ele) => ele.isFavorite)

      setDisplayTab(displayButton)
    }
  }, [clockDataForAllCountries, allClockData])

  useEffect(() => {
    const intervalID = setInterval(() => {
      getCurrentTime(allClockData)
    }, 1000)

    return () => clearInterval(intervalID)
  }, [allClockData])

  useEffect(() => {
    document.querySelector('body').style.overflow = visible ? 'hidden' : 'auto'
  }, [visible])

  // useEffect to initialize state for testing purposes
  useEffect(() => {
    if (mockDisplayTab) {
      setDisplayTab(mockDisplayTab)
      setSelectedCountryData(mockSelectedCountryData)
      setSelectedCountry(mockSelectedCountry)
    }
  }, [])

  const getAllCountryTimeDetails = async () => {
    setLoading(true)
    setErrorState(false)

    try {
      const userId = userDetails?.id || 0
      const {
        data: { returnLst }
      } = await apiAdapterCoffeeWeb.getCountryTimeZone({
        userId,
        pageNumber: 1,
        pageSize: 243
      })

      let finalData = [...returnLst]

      // ---------------- Guest User Logic ----------------
      if (!userDetails) {
        const storedOrder = getLocalDigitalClocksReorder()

        if (storedOrder?.length) {
          // reorder API response based on stored order
          const reordered = storedOrder.map((name) => returnLst.find((c) => c.countryName === name)).filter(Boolean)

          // add missing countries if new ones appear
          const remaining = returnLst.filter((c) => !storedOrder.includes(c.countryName))

          finalData = [...reordered, ...remaining]
        }

        // For guest user, adjust numScroll
        setNumScroll(returnLst.length % 5)
      }

      // ---------------- Favorites Logic ----------------
      const favoriteCountries = finalData.filter((c) => c.isFavorite)
      const nonFavorites = finalData.filter(({ countryId }) => !favoriteCountries.some((fav) => fav.countryId === countryId))

      if (favoriteCountries.length) {
        const savedTab = getLocalClockTab('clockTab')

        if (savedTab === 'All Clock') {
          setLocalWithClockTab('All Clock')
          setClockTab('All Clock')
        } else {
          setLocalWithClockTab('My Favourite')
          setClockTab('My Favourite')
        }
      }

      // ---------------- State Updates ----------------
      setPageLoad(true)
      setClockDataForAllCountries(finalData.slice(0, 17))
      setAllClockData(finalData)
      setFavoriteCountryClock(favoriteCountries)
      setPickListTargetData(favoriteCountries)
      setPickListSourceData(nonFavorites)

      getCurrentTime(finalData)

      if (!userDetails) {
        setSelectedCountry(finalData[0]) // only set for guest user
      }
    } catch (error) {
      setErrorState(true)
    } finally {
      setLoading(false)
    }
  }

  const postReorderDigitalClocks = async (draggedItem, targetItem) => {
    const reorderList = (list) => {
      const updated = [...list]
      const draggedIndex = updated.findIndex((c) => c.countryName === draggedItem.countryName)
      const targetIndex = updated.findIndex((c) => c.countryName === targetItem.countryName)

      if (draggedIndex === -1 || targetIndex === -1) return list

      updated.splice(draggedIndex, 1)
      updated.splice(targetIndex, 0, draggedItem)

      return updated
    }

    try {
      let newAllClockData = allClockData
      let newFavoriteData = favoriteCountryClock

      if (clockTab === 'All Clock') {
        //  reorder all clocks
        newAllClockData = reorderList(allClockData)
        const newVisibleData = reorderList(clockDataForAllCountries)

        setAllClockData(newAllClockData)
        setClockDataForAllCountries(newVisibleData)
      } else {
        //  reorder only favorites
        newFavoriteData = reorderList(favoriteCountryClock)

        setFavoriteCountryClock(newFavoriteData)
        setPickListTargetData(newFavoriteData)
      }

      if (userDetails?.id) {
        //  prepare full sequence (all countries, not just swapped ones)
        const fullSequence = clockTab === 'All Clock' ? newAllClockData.map((c) => c.countryId).join(',') : newFavoriteData.map((c) => c.countryId).join(',')

        await apiAdapterCoffeeWeb.postCountryForReorder({
          userId: userDetails.id,
          userCountrySequence: fullSequence
        })
      } else {
        //  guest → persist locally
        // eslint-disable-next-line
        if (clockTab === 'All Clock') {
          setLocalDigitalClocksReorder(newAllClockData.map((c) => c.countryName))
        } else {
          setLocalDigitalClocksReorder(newFavoriteData.map((c) => c.countryName))
        }
      }
    } catch (err) {
      showError({
        title: t('ERROR_TITLE'),
        message: `<p>${t('SOMETHING_WENT_WRONG')}</p><p>${t('TRY_AGAIN_MESSAGE')}</p>`,
        buttonLabel: t('OK')
      })
    }
  }

  const getCurrentTime = (clockData) => {
    const analogClockTime = {}
    const newWeekDay = {}
    const digitalTime = {}
    const digitalPeriod = {}
    const timeForDigitalClockClassName = {}
    const digitalClock24Hour = {}

    const getTime = (timeZone, options) => new Date().toLocaleTimeString('en-US', { timeZone, ...options })

    clockData.forEach((item) => {
      const options = {
        timeZone: item.timeZone,
        weekday: 'long',
        hour12: false
      }

      const digitalOptions = {
        timeZone: item.timeZone,
        hour12: true,
        hour: 'numeric',
        minute: 'numeric'
      }

      const options24Hour = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
        timeZone: item.timeZone
      }

      const currentTimeForAnalogClock = getTime(item.timeZone)
      const currentTimeForDigitalClock = getTime(item.timeZone, digitalOptions)
      const currentTime24Hour = getTime(item.timeZone, options24Hour)

      const [time, period] = currentTimeForDigitalClock.split(' ')
      const currentDay = new Date().toLocaleDateString('en-us', options)

      analogClockTime[item.countryName] = currentTimeForAnalogClock
      timeForDigitalClockClassName[item.countryName] = currentTimeForDigitalClock
      digitalClock24Hour[item.countryName] = currentTime24Hour
      digitalTime[item.countryName] = time
      digitalPeriod[item.countryName] = period
      newWeekDay[item.countryName] = currentDay
    })

    setCountryTime(analogClockTime)
    setDigitalClockTime(digitalTime)
    setDigitalPeriod(digitalPeriod)
    setCountryDay(newWeekDay)
    setDigitalClock(timeForDigitalClockClassName)
    setDigitalTimeHour(digitalClock24Hour)
  }

  const getClockClassName = (timeString) => {
    if (timeString) {
      const timeParts = timeString.split(':')
      const period = timeString.split(' ')

      const hours = parseInt(timeParts[0], 10)

      const isNightTime = (hours >= 6 && hours < 12 && period[1] === 'PM') || ((hours < 6 || hours === 12) && period[1] === 'AM')

      return isNightTime ? ` ${selectedClockType === 'Digital' ? 'digital-clock-dark' : 'analog-clock-dark'}` : ` ${selectedClockType === 'Digital' ? 'digital-clock-light' : 'analog-clock-light'}`
    }

    return ''
  }

  const getGeolocation = async () => {
    setLoading(true)
    setSelectedCountry(clockDataForAllCountries[2])

    try {
      if (!userDetails) {
        const locationResponse = await commonMethods.searchLocation()

        modifyCountryPositions(locationResponse?.country, locationResponse?.region, locationResponse?.name)
      }
    } catch {
      if (!userDetails) {
        const ipLocationResponse = await commonMethods.fetchIPDetails()

        modifyCountryPositions(ipLocationResponse?.city, ipLocationResponse?.region, ipLocationResponse?.countryName)
      }
    } finally {
      setLoading(false)
    }
  }

  const modifyCountryPositions = (...args) => {
    setLoading(true)

    let remainingCountries
    let currentCountry = clockDataForAllCountries?.find((item) => args.some((arg) => item.countryName === arg))

    if (currentCountry && !isCountryPresent && !userDetails) {
      remainingCountries = clockDataForAllCountries.filter((item) => item?.countryName !== currentCountry.countryName)
      remainingCountries.splice(2, 0, currentCountry)
      setIsCountryPresent(true)
      setClockDataForAllCountries(remainingCountries)
    } else if (!currentCountry && !isCountryPresent && !userDetails) {
      remainingCountries = clockDataForAllCountries.filter((item) => item?.countryName !== 'India')
      remainingCountries.splice(2, 0, defaultCountryData)
      currentCountry = defaultCountryData
      setIsCountryPresent(true)
      setClockDataForAllCountries(remainingCountries)
    }

    setSelectedCountry(currentCountry)
  }

  const onClockTabChange = (event) => {
    setPage(0)
    handleClearFilter()

    const selectedClockTab = event.target.value

    setClockTab(selectedClockTab)
    setLocalWithClockTab(selectedClockTab)
  }

  const handleAddButtonClick = () => {
    handleClearFilter()

    setVisible(true)

    // user-analytics
    trackEvent(USER_EVENTS.ABOUT_US_CLOCK_SETTINGS)
  }

  const handleCountrySelection = (selectedCountry) => {
    setPage(0)

    const filteredCountry = allClockData?.filter((country) => country?.countryName === selectedCountry?.countryName)

    setSelectedCountryData(filteredCountry?.length > 0 ? filteredCountry[0] : null)
  }

  if (selectedCountryData) {
    carouselValue = [selectedCountryData]
  } else {
    carouselValue = clockTab === 'All Clock' ? clockDataForAllCountries : favoriteCountryClock
  }

  const handleClearFilter = () => {
    setFilterCountry({})
    setSelectedCountryData(null)
  }

  const pageChange = (event) => {
    setPage(event.page)
  }

  // Helper function to format date with timezone and offset e.g. Mon 14 Mar (+5:30)
  function formatCountryDateTimeObj(item) {
    const now = new Date()
    const userItem = clockDataForAllCountries

    if (!userItem) return { date: '', offset: '' }

    function getOffsetMinutes(timeZone) {
      const formatter = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'shortOffset' })
      const parts = formatter.formatToParts(now)
      const tz = parts.find((p) => p.type === 'timeZoneName')?.value || ''
      const match = tz.match(/GMT([+-]\d{1,2})(?::(\d{2}))?/)

      if (!match) return 0
      const sign = match[1].startsWith('-') ? -1 : 1
      const hours = Math.abs(parseInt(match[1], 10))
      const minutes = match[2] ? parseInt(match[2], 10) : 0

      return sign * (hours * 60 + minutes)
    }

    const targetOffset = getOffsetMinutes(item?.timeZone)
    const userOffset = getOffsetMinutes(userItem?.timeZone)
    const diffMinutes = targetOffset - userOffset
    const absMinutes = Math.abs(diffMinutes)

    let offset = ''

    if (absMinutes !== 0 && item.countryName !== userItem) {
      const sign = diffMinutes >= 0 ? '+' : '-'
      const hours = String(Math.floor(absMinutes / 60))
      const minutes = String(absMinutes % 60).padStart(2, '0')

      offset = `${sign}${hours}:${minutes}`
    }

    const weekday = new Intl.DateTimeFormat('en-US', { timeZone: item.timeZone, weekday: 'short' }).format(now)
    const day = new Intl.DateTimeFormat('en-US', { timeZone: item.timeZone, day: 'numeric' }).format(now)
    const month = new Intl.DateTimeFormat('en-US', { timeZone: item.timeZone, month: 'short' }).format(now)

    return { date: `${weekday} ${day} ${month}`, offset }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e, targetItem) => {
    e.preventDefault()
    if (!draggedItem || draggedItem.countryName === targetItem.countryName) return

    const reorderList = (list) => {
      const updated = [...list]
      const draggedIndex = updated.findIndex((c) => c.countryName === draggedItem.countryName)
      const targetIndex = updated.findIndex((c) => c.countryName === targetItem.countryName)

      if (draggedIndex === -1 || targetIndex === -1) return list

      updated.splice(draggedIndex, 1)
      updated.splice(targetIndex, 0, draggedItem)

      return updated
    }

    // Reorder all list
    const newAllClockData = reorderList(allClockData)

    // Update state with full data
    setAllClockData(newAllClockData)

    // Refresh the visible slice based on the new order
    const newVisibleData = newAllClockData.slice(0, clockDataForAllCountries.length)

    setClockDataForAllCountries(newVisibleData)

    // Save the full order to local storage
    setLocalDigitalClocksReorder(newAllClockData.map((c) => c.countryName))

    // For logged-in users, call API
    if (userDetails?.id) {
      postReorderDigitalClocks(draggedItem, targetItem)
    }

    setDraggedItem(null)
  }

  const handleChangeCountry = (event) => {
    const chosenCountry = event.target.value

    setFilterCountry(chosenCountry)
    setSelectedCountry(chosenCountry)
    handleCountrySelection(chosenCountry)

    // user-analytics
    trackEvent(USER_EVENTS.ABOUT_US_COUNTRY_DROPDOWN)
  }

  const getMaxPage = () => Math.max(0, Math.ceil((allClockData?.length || 0) / numVisible) - 1)

  const handleDragStart = (e, item) => {
    setDraggedItem(item)

    // Create ghost clone
    const ghost = e.target.cloneNode(true)

    ghost.style.position = 'fixed'
    ghost.style.pointerEvents = 'none'
    ghost.style.opacity = '0.8'
    ghost.style.zIndex = '9999'
    ghost.style.width = `${e.target.offsetWidth}px`
    ghost.style.height = `${e.target.offsetHeight}px`
    document.body.appendChild(ghost)
    dragGhostRef.current = ghost

    // Follow cursor
    const move = (ev) => {
      ghost.style.left = `${ev.clientX + 10}px`
      ghost.style.top = `${ev.clientY + 10}px`
    }

    document.addEventListener('mousemove', move)
    ghost._cleanup = () => document.removeEventListener('mousemove', move)
  }

  const handleDragOverCarousel = (e) => {
    if (!draggedItem) return
    e.preventDefault()

    const container = carouselRef.current

    if (!container) return

    const rect = container.getBoundingClientRect()
    const edgeThreshold = 80

    // find nav buttons if they exist
    const nextBtn = container.querySelector('.p-carousel-next')
    const prevBtn = container.querySelector('.p-carousel-prev')

    // check if cursor is over next/prev buttons
    if ((nextBtn && nextBtn.getBoundingClientRect().left <= e.clientX && e.clientX <= nextBtn.getBoundingClientRect().right && nextBtn.getBoundingClientRect().top <= e.clientY && e.clientY <= nextBtn.getBoundingClientRect().bottom) || (prevBtn && prevBtn.getBoundingClientRect().left <= e.clientX && e.clientX <= prevBtn.getBoundingClientRect().right && prevBtn.getBoundingClientRect().top <= e.clientY && e.clientY <= prevBtn.getBoundingClientRect().bottom)) {
      stopAutoScroll()

      return
    }

    // edge detection (only if not over buttons)
    if (e.clientX > rect.right - edgeThreshold) {
      isHoveringEdgeRef.current = { side: 'right', distance: rect.right - e.clientX }
      startAutoScroll()
    } else if (e.clientX < rect.left + edgeThreshold) {
      isHoveringEdgeRef.current = { side: 'left', distance: e.clientX - rect.left }
      startAutoScroll()
    } else {
      stopAutoScroll()
    }
  }

  const startAutoScroll = () => {
    if (autoScrollRef.current) return

    const step = (timestamp) => {
      if (!isHoveringEdgeRef.current) return

      const { side, distance } = isHoveringEdgeRef.current

      // closer to edge = faster scroll
      const maxSpeed = 500 // ms between scrolls at very edge
      const minSpeed = 1200 // ms between scrolls if just inside threshold
      const ratio = Math.min(1, Math.max(0, distance / 80)) // 0 = at edge, 1 = safe zone
      const delay = minSpeed - (minSpeed - maxSpeed) * (1 - ratio)

      if (timestamp - lastScrollTimeRef.current > delay) {
        if (side === 'right') {
          setPage((p) => Math.min(p + 1, getMaxPage()))
        } else if (side === 'left') {
          setPage((p) => Math.max(p - 1, 0))
        }
        lastScrollTimeRef.current = timestamp
      }

      autoScrollRef.current = requestAnimationFrame(step)
    }

    autoScrollRef.current = requestAnimationFrame(step)
  }

  const stopAutoScroll = () => {
    if (autoScrollRef.current) {
      cancelAnimationFrame(autoScrollRef.current)
      autoScrollRef.current = null
    }
    isHoveringEdgeRef.current = false
  }

  const handleDragEnd = () => {
    setDraggedItem(null)
    stopAutoScroll()
    if (dragGhostRef.current) {
      dragGhostRef.current._cleanup?.()
      dragGhostRef.current.remove()
      dragGhostRef.current = null
    }
  }

  const responsiveOptions = [
    {
      breakpoint: '1400px',
      numVisible: 4,
      numScroll: 1
    },
    {
      breakpoint: '1199px',
      numVisible: 3,
      numScroll: 1
    },

    {
      breakpoint: '575px',
      numVisible: 1,
      numScroll: 1
    }
  ]

  const LoaderText = () => <div className="no-data-title"> {isLoading ? t('FETCHING') : t('NO_DATA_FOUND')} </div>

  const productTemplate = (item) => {
    const { date, offset } = formatCountryDateTimeObj(item)

    return selectedClockType === 'Analog' ? (
      <div className="clock-container">
        <div className="clock-content">
          <div className="clock-details-info" data-testid="analog-clock">
            <div className="country-name-info" data-testid="analogClock-countryName-info">
              {item.countryName}
            </div>
            <Clock value={countryTime[item.countryName]} renderNumbers={false} hourMarksLength={10} minuteMarksLength={4} size={windowWidth <= 1024 ? 90 : 140} className={getClockClassName(countryTime[item.countryName])} data-testid="clock" />
            <img src={item.flagURL} alt={`${item.countryName} Flag`} className={`${selectedClockType === 'Digital' ? 'country-flag-info' : 'analog-country-flag'}`} title="analogClock-flag-info" />
          </div>
          <div className="time-details-container">
            <div className="weekday-info" data-testid="analogClock-weekday-info"></div>

            <div className="current-time-info" data-testid="analogClock-time-info">
              {digitalClockTime[item.countryName]} {digitalPeriod[item.countryName]}
            </div>

            <div className="formatted-time-difference">
              {date} {offset && <span className="time-offset">({offset})</span>}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className="digital-clock-container" data-testid="digital-clock">
        <div className="digital-clock-wrapper">
          <div className="digital-clock">
            <div className={`digital-clock-item ${getClockClassName(digitalClock[item.countryName])}`} draggable onDragStart={(e) => handleDragStart(e, item)} onDragOver={(e) => handleDragOver(e)} onDrop={(e) => handleDrop(e, item)}>
              <div className="digital-clock-time-wrapper">
                <div className="country-flag-wrapper">
                  <img src={item.flagURL} alt={`${item.countryName} Flag`} className={`${selectedClockType === 'Digital' ? 'country-flag-info' : 'analog-country-flag'}`} title="digitalClock-flag-info" />
                </div>
                <div className="digital-country-name-info" data-testid="digitalClock-countryName-info">
                  {item?.countryName?.length < 10 ? item?.countryName : item?.iso3}
                </div>

                {timeFormat === '12-hour' ? (
                  //  12 Hour Format
                  <div className="digital-time-info" data-testid="digital-time-info">
                    {`${String(digitalClockTime[item?.countryName]?.split(':')[0]).padStart(2, '0')}:${String(digitalClockTime[item.countryName]?.split(':')[1]).padStart(2, '0')}`} {digitalPeriod[item.countryName]}
                  </div>
                ) : (
                  // 24 Hour Format
                  <div className="digital-time-info" data-testid="digital-time-hour">
                    {`${String(digitalTimeHour[item?.countryName]?.split(':')[0]).padStart(2, '0')}:${String(digitalTimeHour[item.countryName]?.split(':')[1]).padStart(2, '0')}`}
                  </div>
                )}

                <div className="digital-weekday-info" data-testid="digital-weekday">
                  {date} {offset && <span className="time-offset">({offset})</span>}
                </div>
              </div>

              <div className="drag-icon">
                <DragIcon className="drag-svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="country-clock-container" data-testid="country-clock">
      {userDetails && (
        <div className="search-container">
          <div className="select-button-wrapper">{displayTab && <SelectButton value={clockTab} onChange={onClockTabChange} options={clockList} className="select-button" allowEmpty={false} data-testid="webview-select-button" />}</div>
          <div className="search-country-wrapper">
            <div className="country-dropdown-wrapper">
              <CustomDropdown value={filterCountry} filterItems="countryName,searchTag" options={clockTab === 'All Clock' ? allClockData : favoriteCountryClock} optionLabel={'searchTag' || 'countryName'} showFlags={true} filter={true} error={errorState} placeholder={t('SELECT_COUNTRY')} onChange={handleChangeCountry} className="clock-filter-dropdown-web" testId="country-dropdown" />

              {selectedCountryData && (
                <div className="clear-icon" onClick={handleClearFilter} data-testid="clear-icon">
                  <i className="pi pi-times" />
                  <div className="close-icon-tool-tip">
                    <div>{t('CLOSE')}</div>
                  </div>
                </div>
              )}
            </div>
            <div className="setting-icon" onClick={handleAddButtonClick} data-testid="clockSetting-icon">
              <ClockSetting />
              <div className="setting-tooltip">
                <div>{t('CLOCK_SETTINGS')}</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {windowWidth >= 767 ? (
        // Web View UI
        <div className="carousel-wrapper" ref={carouselRef} onDragOver={handleDragOverCarousel} data-testid="carousel">
          <div ref={containerRef}>
            {clockDataForAllCountries.length === 0 && <LoaderText />}
            <Carousel key={numVisible} value={carouselValue} responsiveOptions={responsiveOptions} numVisible={numVisible} numScroll={numScroll} itemTemplate={productTemplate} showIndicators={false} onPageChange={pageChange} page={page} showNavigators={clockDataForAllCountries?.length ?? false} onDragEnd={handleDragEnd} />
          </div>
        </div>
      ) : (
        <div className="mobile-view-container" data-testid="mobile-view-container">
          {/* Mobile View UI */}
          {userDetails ? (
            <div className="mobile-view-header-wrapper">
              <div className={`${displayTab ? 'select-button-wrapper' : 'remove-button'}`}>
                <SelectButton value={clockTab} onChange={onClockTabChange} options={clockList} className="select-button" allowEmpty={false} data-testid="mobileView-select-button" />
              </div>

              <div className={`${displayTab ? 'setting-wrapper' : 'setting-button-container'}`}>
                <div className="dropdown-wrapper">
                  <CustomDropdown value={selectedCountry} options={clockTab === 'All Clock' ? allClockData : favoriteCountryClock} optionLabel={'countryName'} showFlags={true} filter={true} error={errorState} placeholder={t('SELECT_COUNTRY')} onChange={handleChangeCountry} className="clock-filter-dropdown-mobile" testId="mobileView-country-dropdown" />
                </div>
                <div className="setting-icon">
                  <ClockSetting onClick={handleAddButtonClick} data-testid="clockSetting-icon" />
                </div>
              </div>
            </div>
          ) : (
            <div className="guest-dropdown-wrapper">
              <CustomDropdown value={selectedCountry} options={allClockData} optionLabel={'countryName'} showFlags={true} filter={true} error={errorState} placeholder={t('SELECT_COUNTRY')} onChange={handleChangeCountry} className="clock-filter-dropdown-guest" testId="country-dropdown" />
            </div>
          )}

          <div className="mobile-view-clock-wrapper">
            <div className="clock-content">
              <div className="clock-details-info" data-testid="mobileView-analog-clock">
                {selectedClockType === 'Analog' ? (
                  <>
                    {selectedCountry?.countryName ? (
                      <>
                        <Clock value={countryTime[selectedCountry?.countryName]} renderNumbers={false} hourMarksLength={10} minuteMarksLength={4} size={160} className={getClockClassName(countryTime[selectedCountry?.countryName])} />
                        <img src={selectedCountry?.flagURL} alt={`${selectedCountry?.countryName} Flag`} className={`${selectedClockType === 'Digital' ? 'country-flag-info' : 'analog-country-flag'}`} title="analog-countryFlag" />
                      </>
                    ) : (
                      <div data-testid="mobileView-isLoading">{isLoading ? t('FETCHING') : t('NO_DATA_FOUND')}</div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="digital-clock-container">
                      <div className="digital-clock-wrapper">
                        <div className="digital-clock" data-testid="mobileView-digital-clock">
                          <div className={`digital-clock-item ${getClockClassName(digitalClock[selectedCountry?.countryName])}`} data-testid="countryName-info">
                            <div className="digital-clock-time-wrapper">
                              {/* Country Flag in Clock */}
                              <div className="country-flag-wrapper">
                                <img src={selectedCountry?.flagURL} alt={`${selectedCountry?.countryName} Flag`} className={`${selectedClockType === 'Digital' ? 'country-flag-info' : 'analog-country-flag'}`} title="digitalClock-flag-info" />
                              </div>
                              <div className="digital-country-name-info" data-testid="digitalClock-countryName-info">
                                {selectedCountry?.countryName}
                              </div>
                              {timeFormat === '12-hour' ? (
                                <>
                                  {/* 12 Hour Format */}
                                  <div className="digital-time-info" data-testid="digital-time-info">
                                    {`${String(digitalClockTime[selectedCountry?.countryName]?.split(':')[0]).padStart(2, '0')}:${String(digitalClockTime[selectedCountry?.countryName]?.split(':')[1]).padStart(2, '0')}`} {digitalPeriod[selectedCountry?.countryName]}
                                  </div>
                                </>
                              ) : (
                                <>
                                  {/* 24 Hour Format */}
                                  <div className="digital-time-info" data-testid="digital-time-hour">
                                    {`${String(digitalTimeHour[selectedCountry?.countryName]?.split(':')[0]).padStart(2, '0')}:${String(digitalTimeHour[selectedCountry?.countryName]?.split(':')[1]).padStart(2, '0')}`}
                                  </div>
                                </>
                              )}
                              <div className="digital-weekday-info" data-testid="digital-weekday">
                                {selectedCountry &&
                                  (() => {
                                    const { date, offset } = formatCountryDateTimeObj(selectedCountry)

                                    return (
                                      <>
                                        {date} {offset && <span className="time-offset">({offset})</span>}
                                      </>
                                    )
                                  })()}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/*  Kept for future use */}
              {/* <div className="time-details-container">
                <div className="weekday-info" data-testid="digital-weekdays">
                  {countryDay[selectedCountry?.countryName]}
                  {countryDay[selectedCountry?.countryName] && ','}
                </div>
                <div className="current-time-info" data-testid="current-time">
                  {digitalClockTime[selectedCountry?.countryName]}
                </div>
                <div className="current-time-info" data-testid="current-period">
                  {digitalPeriod[selectedCountry?.countryName]}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      )}

      <div className="clock-setting-layout">{visible && <ClockSettings setDisplayTab={setDisplayTab} visible={visible} setPage={setPage} setVisible={setVisible} pickListSourceData={pickListSourceData} setPickListSourceData={setPickListSourceData} favoriteCountryClockData={favoriteCountryClock} setFavoriteCountryClock={setFavoriteCountryClock} pickListTargetData={pickListTargetData} setPickListTargetData={setPickListTargetData} setClockTab={setClockTab} />}</div>
    </div>
  )
}

export default ErrorMessageModal(AnalogClock)
